/** @format */

import Icon, { DeleteOutlined, DownOutlined, EditOutlined, FileOutlined } from '@ant-design/icons';
import { Col, Form, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { GetLocalStorageValue } from '../../_config/utils/get-local-storage-value.util';
import CustomButton from '../../v2-components/Antd/Button';
import CustomDivider from '../../v2-components/Antd/Divider';
import CustomDropdown from '../../v2-components/Antd/Dropdown';
import CustomFormItem from '../../v2-components/Antd/FormItem';
import CustomInput from '../../v2-components/Antd/Input';
import CustomModal from '../../v2-components/Antd/Modal';
import CustomTable from '../../v2-components/Antd/Table';
import CustomUpload from '../../v2-components/Antd/Upload';
import LoadingModal from '../../v2-components/LoadingModal';
import { CustomNotification } from '../../v2-components/Notification';
import { LOCAL_STORAGE } from '../../v2-config/constants/local-storage.constant';
import { TYPE_LETTER_ADAPTER } from './constants/type-letter-adapter.constant';
import { checkUrl } from './handle/check-url.handle';
import { getKeyByValue } from './handle/get-key-by-value.handle';
import { handleSearchParams } from './handle/search-params.handle';
import { Service } from './service';

import './style.scss';

export default function LettersV2() {
	const history = useHistory();
	const location = useLocation();
	const searchParams = new URLSearchParams(location?.search);
	const [loading, setLoading] = useState(true);
	const [pharmacyLetters, setPharmacyLetters] = useState([]);
	const [typeLetter, setTypeLetter] = useState(null);
	const [openEditModal, setOpenEditModal] = useState(false);
	const [record, setRecord] = useState();
	const [file, setFile] = useState();
	const [fileName, setFileName] = useState(null);
	const [form] = Form.useForm();
	const [openLoadingModal, setOpenLoadingModal] = useState(false);
	const [renderData, setRenderData] = useState(false);
	const [pagination, setPagination] = useState();
	const page = searchParams.get('page');
	const { pharmacy } = GetLocalStorageValue(LOCAL_STORAGE.USER);
	const { token } = GetLocalStorageValue('userInfo');

	useEffect(() => {
		new Service()
			.getLetters(pharmacy, typeLetter, page)
			.then((lettersResponse) => {
				setPagination(lettersResponse);
				setPharmacyLetters(
					lettersResponse?.data?.map((item, index) => ({
						...item,
						key: index,
					})),
				);
				setLoading(false);
			})
			.catch((error) => {
				CustomNotification({ type: 'error', description: 'Ha ocurrido un error al obtener los recursos:', error });
			});
	}, [pharmacy, typeLetter, renderData, page]);

	const handleEditModal = (record) => {
		setRenderData(false);
		setRecord(record);
		form.setFieldsValue({ pharmacy: record?.pharmacy, letter: TYPE_LETTER_ADAPTER[record?.letter], filename: record[record?.letter] });
		setOpenEditModal(true);
	};

	const handleUpload = (info) => {
		if (info.fileList.length > 0) {
			setFile(info.fileList[0]);
			form.setFieldValue('filename', info.fileList[0].name);
			setFileName(info.fileList[0].name);
		}
	};

	const handleDeleteFile = () => {
		setFileName(null);
		setFile(null);
		form.setFieldValue('filename', null);
	};

	const handleCloseModal = () => {
		setOpenEditModal(false);
	};

	const handleOnFinish = (values) => {
		if (!file) {
			setOpenLoadingModal(true);
			setOpenEditModal(false);
			new Service()
				.updateLetterOnlyType(record?._id, { [getKeyByValue(TYPE_LETTER_ADAPTER, values.letter)]: null }, token)
				.then((response) => {
					if (!response.pharmacy) {
						setOpenLoadingModal(false);
						return CustomNotification({ type: 'error', description: 'Ha ocurrido un error al cargar el documento' });
					}
					setOpenLoadingModal(false);
					form.resetFields();
					setRenderData(true);
					return CustomNotification({
						type: 'success',
						description: 'Documento actualizado exitosamente',
					});
				})
				.catch((error) => {
					CustomNotification({ type: 'error', description: 'Ha ocurrido un error al cargar el documento' });
					console.log('[ERROR]:', error);
				});
		} else {
			const formData = new FormData();
			formData.append('file', file.originFileObj);
			setOpenLoadingModal(true);
			setOpenEditModal(false);
			const type = getKeyByValue(TYPE_LETTER_ADAPTER, values.letter);
			new Service()
				.updateLetter(record?._id, type, formData, token)
				.then((response) => {
					if (!response.pharmacy) {
						setOpenLoadingModal(false);
						return CustomNotification({
							type: 'error',
							message: 'Error',
							description: 'Ups..ocurrió un error al cargar el archivo. Tenga en cuenta de que sea de tipo PDF',
						});
					}
					setOpenLoadingModal(false);
					form.resetFields();
					setRenderData(true);

					return CustomNotification({ type: 'success', description: 'Documento actualizado exitosamente' });
				})
				.catch((error) => {
					CustomNotification({ type: 'error', description: 'Ha ocurrido un error al cargar el documento' });
				});
		}
	};

	const items = [
		{
			key: '1',
			label: 'Todos',
			onClick: () => setTypeLetter(null),
		},
		{
			key: '2',
			label: 'Carta de desabastecimiento',
			onClick: () => setTypeLetter('shortage_letter'),
		},
		{
			key: '3',
			label: 'Políticas y devoluciones',
			onClick: () => setTypeLetter('faq'),
		},
		{
			key: '4',
			label: 'Resolución de venta electrónica',
			onClick: () => setTypeLetter('electronic_sales_resolution'),
		},
	];

	const columns = [
		{
			align: 'center',
			title: 'Farmacia',
			key: 'pharmacy',
			dataIndex: 'pharmacy',
			render: (text, record) => record.pharmacy === 'fanich' ? 'Anich' : record.pharmacy,
		},
		{
			align: 'center',
			title: (
				<CustomDropdown menu={{ items }} trigger={['click']}>
					<span style={{ cursor: 'pointer' }}>
						Tipo de documento <DownOutlined />
					</span>
				</CustomDropdown>
			),
			key: 'letter',
			dataIndex: 'letter',
			render: (letter, record) => TYPE_LETTER_ADAPTER[letter],
		},
		{
			align: 'center',
			title: 'Archivo',
			key: 'file',
			dataIndex: 'letter',
			render: (text, record) => {
				return (
					<a href={record[text]} target="_blank" rel="noreferrer noopener" className="link-voucher">
						<Icon className="link-voucher" component={FileOutlined} style={checkUrl(record[text])} />
					</a>
				);
			},
		},
		{
			align: 'center',
			key: 'edit',
			title: 'Editar',
			render: (record) => <Icon onClick={() => handleEditModal(record)} className="disscount-icon" component={EditOutlined} />,
		},
	];

	const handlePageChange = (page) => {
		searchParams.set('page', page);
		history.push({
			pathname: location?.pathname,
			search: handleSearchParams(searchParams),
		});
	};

	const paginationConfig = {
		current: pagination?.currentPage,
		pageSize: pagination?.itemsPerPage,
		total: pagination?.totalItems,
		showSizeChanger: false,
		onChange: (page) => handlePageChange(page),
	};

	return (
		<div className="letters-container">
			<Row>
				<Col span={8}>
					<h2>Cartas</h2>
				</Col>
			</Row>
			<Col>
				<h3>Cartas, documentos legales y planillas a publicar en la web</h3>
				<p>En la web estan dispuestos los vinculos para los 3 documentos, procure completarlos.</p>
				<CustomTable loading={loading} columns={columns} dataSource={pharmacyLetters} pagination={paginationConfig} />
			</Col>
			<CustomModal onCancel={handleCloseModal} open={openEditModal} footer={null} destroyOnClose={true}>
				<h3>Editar carta o documento</h3>
				<CustomDivider />
				<h4>Datos</h4>
				<Form form={form} onFinish={(values) => handleOnFinish(values)} autoComplete="off">
					<Row gutter={[16, 16]}>
						<Col span={12}>
							<h4>Farmacia</h4>
							<CustomFormItem name="pharmacy">
								<CustomInput disabled />
							</CustomFormItem>
						</Col>
						<Col span={12}>
							<h4>Tipo de documento</h4>
							<CustomFormItem name="letter">
								<CustomInput value={TYPE_LETTER_ADAPTER[record?.letter]} disabled />
							</CustomFormItem>
						</Col>
					</Row>
					<Row gutter={[16, 16]} align="bottom">
						<Col span={14}>
							<h4>Carga del archivo o documento</h4>
							<p>Archivo</p>
							<CustomFormItem name="filename">
								<CustomInput placeholder={'No ha seleccionado ningun archivo'} disabled />
							</CustomFormItem>
						</Col>
						<Col span={6}>
							<CustomFormItem>
								<CustomUpload
									accept=".pdf"
									maxCount={1}
									showUploadList={false}
									listType="picture"
									beforeUpload={() => false}
									multiple={false}
									onChange={(info) => handleUpload(info)}
								>
									<CustomButton>SUBIR ARCHIVO</CustomButton>
								</CustomUpload>
							</CustomFormItem>
						</Col>
						<Col span={4}>
							<CustomFormItem>
								<Icon
									onClick={handleDeleteFile}
									style={{ fontSize: '18px', marginLeft: '25px' }}
									className="delete-icon"
									component={DeleteOutlined}
								/>
							</CustomFormItem>
						</Col>
					</Row>
					<Row justify="end" gutter={[16, 16]} style={{ marginTop: '25px' }}>
						<Col>
							<CustomButton type="default" onClick={() => setOpenEditModal(false)}>
								CANCELAR
							</CustomButton>
						</Col>
						<Col>
							<CustomFormItem>
								<CustomButton
									type="default"
									htmlType="submit"
									disabled={record && fileName === record[record?.letter] ? true : false}
								>
									GUARDAR
								</CustomButton>
							</CustomFormItem>
						</Col>
					</Row>
				</Form>
			</CustomModal>
			<LoadingModal visible={openLoadingModal} />
		</div>
	);
}
